// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"3eaf0afd","453":"0ce91773"}[chunkId] + ".chunk.js";
};